import { render } from "./BiggestChanger.vue?vue&type=template&id=91c56fd8&ts=true"
import script from "./BiggestChanger.vue?vue&type=script&lang=ts"
export * from "./BiggestChanger.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/rickvanwell/Work/Signals/webui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__